// extracted by mini-css-extract-plugin
module.exports = {"fullBackground":"Contact_fullBackground__-PW58","contactForm":"Contact_contactForm__32o6j"};